import {
  cloneElement,
  type CSSProperties,
  type HTMLAttributes,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";
import { clsx } from "clsx";

/**
 * Clones a ReactElement and merges className/style, or returns null if not a valid element.
 */
export const cloneWithClassName = (
  content: ReactNode,
  className: string,
  style?: CSSProperties,
): ReactElement | null => {
  if (!isValidElement(content)) {
    return null;
  }
  const element = content as ReactElement<HTMLAttributes<HTMLElement>>;
  return cloneElement(element, {
    ...element.props,
    className: clsx(element.props.className, className),
    style: style ? { ...style, ...element.props.style } : element.props.style,
  });
};
